import * as yup from 'yup';

import * as routes from 'api/routes';
import { VALIDATION_ERROR } from 'endpoints/index';

export type Params = {
  companyId: string;
  phone: string;
  timeSpot: string;
  message?: string;
  entityType: number;
  fullName: string;
};
export type Result = void;

export const paramsSchema: yup.SchemaOf<Params> = yup.object().shape({
  companyId: yup.string().required(VALIDATION_ERROR.REQUIRED),
  message: yup.string().max(500, VALIDATION_ERROR.TOO_LONG),
  entityType: yup
    .number()
    .required(VALIDATION_ERROR.REQUIRED)
    .integer()
    .min(1, VALIDATION_ERROR.INVALID_FORMAT)
    .max(9, VALIDATION_ERROR.INVALID_FORMAT),
  timeSpot: yup.string().required(VALIDATION_ERROR.REQUIRED),
  phone: yup
    .string()
    .required(VALIDATION_ERROR.REQUIRED)
    .matches(/^\+?[1-9]\d{8,14}$/, VALIDATION_ERROR.INVALID_PHONE_NUMBER),
  fullName: yup.string().required(VALIDATION_ERROR.REQUIRED),
});

export const ROUTE = routes.COMPANY_WEBSITE_SCHEDULE_MEETING;
